<template>
  <div class="datepicker" id="datepicker">
    <div class="calendar-header">
      <transition name="slide-up">
        <div class="text-center w-100">{{showDate}}</div>
      </transition>
    </div>
    <div class="calendar-body">
      <div class="year-container" v-show="mode===displayMode.years">
        <div class="vertical-middle w-100 switcher">
          <div
            :class="[{disappear:generationStart<=minYear}]"
            class="arrow"
            @click="setGenerations(year-12)"
          >
            <img :src="images.leftArrow" alt />
          </div>
          <div class="switch">{{`${generationStart} - ${generationEnd}`}}</div>
          <div
            class="arrow"
            @click="setGenerations(year+12)"
            :class="[{disappear:generationEnd>=maxYear}]"
          >
            <img :src="images.rightArrow" alt />
          </div>
        </div>
        <div class="w-100 table dozen">
          <div
            :key="`s${gi}`"
            class="w-100 table-row quarter"
            v-for="(generation,gi) in generations"
          >
            <div
              :key="yi"
              tabindex="-1"
              v-for="(y,yi) in generation"
              :class="setYearStatus(y)"
              @click="year=y;mode=displayMode.months;"
            >{{y}}</div>
          </div>
        </div>
      </div>
      <div class="month-container" v-show="mode===displayMode.months">
        <div class="vertical-middle w-100 switcher">
          <div
            :class="[{disappear:!ctrlButton.yearPrev}]"
            class="arrow"
            @click="moveYear(operator.decrease)"
          >
            <img :src="images.leftArrow" alt />
          </div>
          <div @click="mode=displayMode.years" class="switch">{{year}}</div>
          <div
            :class="[{disappear:!ctrlButton.yearNext}]"
            class="arrow"
            @click="moveYear(operator.increase)"
          >
            <img :src="images.rightArrow" alt />
          </div>
        </div>
        <div class="w-100 table dozen">
          <div :key="`s${si}`" class="w-100 table-row quarter" v-for="(season,si) in seasons">
            <div
              :key="mi"
              tabindex="-1"
              v-for="(m,mi) in season"
              :class="setMonthStatus(m)"
              @click="month=m+1;mode=displayMode.days;setCalendar(year,month)"
            >{{months[m]}}</div>
          </div>
        </div>
      </div>
      <div class="day-container" v-show="mode===displayMode.days">
        <div class="vertical-middle w-100 switcher">
          <div
            :class="[{disappear:!ctrlButton.monthPrev}]"
            class="arrow"
            @click="setCalendar(last.y,last.m);"
          >
            <img :src="images.leftArrow" alt />
          </div>
          <div @click="mode=displayMode.months" class="switch">{{`${months[month-1]} ${year}`}}</div>
          <div
            :class="[{disappear:!ctrlButton.monthNext}]"
            class="arrow"
            @click="setCalendar(next.y,next.m);"
          >
            <img :src="images.rightArrow" alt />
          </div>
        </div>
        <transition :name="swipe_left?'swipe-left':'swipe-right'">
          <div class="table w-100 content" v-if="year&amp;&amp;month">
            <div class="table-row">
              <div v-for="(wd, wi) in weekdays" :key="wi">{{wd}}</div>
            </div>
            <div class="table-row days" v-for="(week,wi) in weeks" :key="wi">
              <div
                tabindex="-1"
                v-for="(date,di) in week"
                :class="setDateStatus(date)"
                @click="setDate(date)"
                :key="di"
              >{{date.d}}</div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { displayMode, months, weekdays, operator } from "./config";
import images from "../../../core/images";
export default {
  inheritAttrs: false,
  name: "datepicker",
  created() {
    this.init();
  },
  data() {
    return {
      // disappear status
      ctrlButton: {
        yearNext: true,
        yearPrev: true,
        monthNext: true,
        monthPrev: true,
        generationPrev: true,
        generationNext: true
      },
      minTickets: 0,
      maxTickets: 0,
      minDate: null,
      maxDate: null,
      currentTickets: 0,
      currentDate: new Date(),
      mode: displayMode.days,
      year: 0,
      month: 0,
      date: {},
      next: {},
      last: {},
      weeks: [],
      years: [],
      endDate: null,
      startDate: null,
      months: months,
      weekdays: weekdays,
      minYear: 0,
      maxYear: 0,
      generations: [],
      generationEnd: 0,
      generationStart: 0,
      seasons: [0, 1, 2, 3].map(x =>
        Array.from(Array(12).keys(), i => i).slice(x * 3, x * 3 + 3)
      ),
      swipe_left: false
    };
  },
  props: {
    // date format string
    min: { type: String },
    max: { type: String },
    current: String
  },
  methods: {
    init() {
      let current = this.current ? new Date(this.current) : new Date();
      this.currentDate = current;
      this.currentTickets = current.getTime();
      this.minTickets = this.min
        ? new Date(this.min).getTime()
        : -3786854760000;
      this.maxTickets = this.max
        ? new Date(this.max).getTime()
        : // 預設值
          this.currentTickets + 100 * 365 * 24 * 60 * 60 * 1000;
      this.maxDate = new Date(this.maxTickets);
      this.minDate = new Date(this.minTickets);
      this.maxYear = this.maxDate.getFullYear();
      this.minYear = this.minDate.getFullYear();
      this.year = current.getFullYear();
      this.month = current.getMonth() + 1;
      this.date = {
        y: current.getFullYear(),
        m: current.getMonth() + 1,
        d: current.getDate()
      };
      this.setCalendar(this.year, this.month);
    },
    setCalendar(year, month) {
      let weeks = [];
      this.year = year;
      this.month = month;
      let daysInMonth = new Date(this.year, this.month, 0).getDate();
      let firstWeekDayInMonth = new Date(this.year, this.month - 1, 1).getDay();
      let lastWeekDayInMonth = new Date(
        this.year,
        this.month - 1,
        daysInMonth
      ).getDay();
      // 上個月的
      let lastMonth = this.month - 1 < 1 ? 12 : this.month - 1;
      let lastMonthYear = this.month - 1 < 1 ? this.year - 1 : this.year;
      if (firstWeekDayInMonth > 0) {
        // 週一 到 週六
        let daysInLastMonth = new Date(lastMonthYear, lastMonth, 0).getDate();
        for (let i = 0; i < firstWeekDayInMonth; i++) {
          weeks.unshift({
            y: lastMonthYear,
            m: lastMonth,
            d: daysInLastMonth - i
          });
        }
      }
      // 當月
      for (let i = 0; i < daysInMonth; i++) {
        weeks.push({ y: this.year, m: this.month, d: i + 1 });
      }
      // 下個月
      let nextMonth = this.month + 1 > 12 ? 1 : this.month + 1;
      let nextMonthYear = this.month + 1 > 12 ? this.year + 1 : this.year;
      for (let i = 0; i < 20 - lastWeekDayInMonth; i++) {
        weeks.push({ y: nextMonthYear, m: nextMonth, d: i + 1 });
      }
      // 把資訊載入按鈕
      this.last = { y: lastMonthYear, m: lastMonth };
      this.next = { y: nextMonthYear, m: nextMonth };
      this.endDate = weeks[41];
      this.startDate = weeks[0];
      this.weeks = [0, 1, 2, 3, 4, 5].map(x => weeks.slice(x * 7, x * 7 + 7));
      this.setGenerations(this.year);
      this.refreshButton();
    },
    refreshButton() {
      let maxYear = this.maxDate.getFullYear();
      let minYear = this.minDate.getFullYear();
      this.ctrlButton.yearPrev = this.year > this.minYear;
      this.ctrlButton.yearNext = this.year < this.maxYear;
      this.ctrlButton.generationNext = this.generationEnd < maxYear;
      this.ctrlButton.generationPrev = this.generationStart > minYear;
      this.ctrlButton.monthPrev =
        Date.UTC(this.startDate.y, this.startDate.m - 1, this.startDate.d) >
        this.minTickets;
      this.ctrlButton.monthNext =
        Date.UTC(this.year, this.month, 0) < this.maxTickets;
    },
    setDate(date) {
      let dt = new Date(date.y, date.m - 1, date.d);
      this.currentDate = dt;
      this.date = {
        y: dt.getFullYear(),
        m: dt.getMonth() + 1,
        d: dt.getDate()
      };
      this.$emit("change", dt.getTime());
    },
    setDateStatus(date) {
      if (
        Date.UTC(date.y, date.m - 1, date.d) < this.minTickets ||
        Date.UTC(date.y, date.m - 1, date.d) > this.maxTickets
      ) {
        return "extra-light";
      }
      if (
        date.y == this.date.y &&
        date.m == this.date.m &&
        date.d == this.date.d
      ) {
        return "active";
      } else if (this.month != date.m) {
        return "light-color";
      }
      return "";
    },
    setYearStatus(y) {
      if (y === this.year) {
        return "active";
      }
      if (y > this.maxYear || y < this.minYear) {
        return "extra-light";
      }
    },
    setMonthStatus(m) {
      if (m === this.month - 1) {
        return "active";
      }
      if (
        (this.year === this.minYear && m < this.minDate.getMonth()) ||
        (this.year === this.maxYear && m > this.maxDate.getMonth())
      ) {
        return "extra-light";
      }
    },
    setGenerations(currentYear) {
      let years = Array.from(Array(12).keys(), i => currentYear + i - 5);
      let defaultYear = years[5];
      if (defaultYear < this.minYear) {
        defaultYear = this.minYear;
      } else if (defaultYear > this.maxYear) {
        defaultYear = this.maxYear;
      }
      this.year = defaultYear;
      this.generations = [0, 1, 2, 3].map(x => years.slice(x * 3, x * 3 + 3));
      this.generationStart = years[0];
      this.generationEnd = years[years.length - 1];
    },
    moveYear(oper) {
      let currentYear = this.year;
      if (oper === operator.increase) {
        currentYear += 1;
      } else if (oper === operator.decrease) {
        currentYear -= 1;
      }
      this.ctrlButton.yearPrev = currentYear > this.minYear;
      this.ctrlButton.yearNext = currentYear < this.maxYear;
      this.year = currentYear;
    }
  },
  watch: {
    min() {
      this.init();
    },
    max() {
      this.init();
      this.$emit("change", new Date().getTime());
    },
    current() {
      this.init();
    }
  },
  computed: {
    operator() {
      return operator;
    },
    displayMode() {
      return displayMode;
    },
    images() {
      return images;
    },
    showDate() {
      return this.currentDate.toDateString();
    }
  }
};
</script>
<style lang="scss" scoped>
@mixin move-effect() {
  &:hover {
    color: white;
    background: $orange;
    border-color: lighten($orange, 20%);
  }
  &:active,
  &:focus {
    color: white;
    border-style: inset;
    background: $orange;
    border-color: $orange;
  }
}
@mixin default-border() {
  outline: none;
  border-style: solid;
  border-radius: $border-radius;
  border: groove 1.5px transparent;
}

.datepicker {
  width: 100%;
  text-align: center;
  background-color: white;
  border-radius: $border-radius;
  border: groove 1px lighten($orange, 20%);

  .calendar-header {
    color: white;
    padding: 0.5rem;
    background: $orange;
  }
  .calendar-body {
    height: 19rem;
    overflow-y: auto;
    overflow-y: overlay;
    .active {
      color: white;
      background: $orange;
      border-color: $orange;
      border: inset 1.5px $orange !important;
    }

    .disappear {
      opacity: 0;
      pointer-events: none;
    }
    .extra-light {
      opacity: 0.1;
      pointer-events: none;
    }
    .switcher {
      .switch {
        width: 60%;
        cursor: pointer;
        font-size: 1rem;
        display: inline-block;
        line-height: 2rem;
        height: 2rem;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        border-radius: $border-radius;
        &:hover,
        &:active {
          background: $light-gray;
        }
      }
      div.arrow {
        width: 20%;
        img {
          width: 2rem;
          cursor: pointer;
          padding: 0.5rem;
          border-radius: $border-radius;
          &:hover,
          &:active {
            background: $light-gray;
          }
        }
      }
    }
    .dozen {
      .quarter {
        > * {
          padding: 5% 0;
          @include default-border();
          @include move-effect();
        }
      }
    }
    .year-container {
      .switcher {
        .switch {
          pointer-events: none;
        }
      }
    }
    .day-container {
      .content {
        padding: 0.5rem;
        border-top: solid 1px rgba(250, 168, 53, 0.15);
        > .table-row {
          > * {
            padding: 0.25rem;
            @include default-border();
          }
          &.days > * {
            cursor: pointer;
            @include move-effect();
          }
        }
        .light-color {
          color: $light-gray;
        }
      }
    }
  }
}
</style>